import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../../models'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    render: store.actions.request({
      input: store.actions.Data.asIs<{
        request: models.page.Rendering.Request
      }>(),
      output: store.actions.Data.asIs<{
        rendering: ents.core.mosaic.Page.Rendering
      }>(),
      reducers: {
        request: ({ state }) => ({
          ...state,
          error: undefined,
          isLoading: true,
          page: undefined,
        }),
        success: ({
          data: {
            response: { rendering },
          },
          state,
        }) => ({
          ...state,
          page: rendering,
          isLoading: false,
          error: undefined,
        }),
        error: ({ data: { error }, state }) => ({
          ...state,
          error,
          isLoading: false,
          page: undefined,
        }),
        /* eslint-enable sort-keys */
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
